import jwt_decode from 'jwt-decode';
import { FC, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../app/authentication/AuthServiceProvider';

const AuthCallbackPage: FC = () => {
    const navigateTo = useNavigate();
    const userManager = useContext(AuthContext);

    useEffect(
      () => {
        userManager.signinRedirectCallback()
            .then((user) => {
                const returnUrl = sessionStorage.getItem('returnUrl');
                sessionStorage.removeItem('returnUrl');

                const { tenant } = jwt_decode<{ tenant: string }>(user.access_token);
                localStorage.setItem('selectedTenantId', tenant);
                sessionStorage.removeItem('isSilentLogin');

                navigateTo(returnUrl ?? '/');
            });
        },
        [navigateTo, userManager],
    );

    return (
        <div>
            <label>Authenticating</label>
        </div>
    )

};

export default AuthCallbackPage;